import React, { useState, useEffect, useContext } from "react";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";
import { HOST_URL } from "../../../../../Config";
import { getUserData, localStoragekey } from "../../../../Common/Utility/Utils";
import axios from "axios";
import { StoreContext } from "../../../../../Store/Provider";
import { CircularProgress } from "@material-ui/core";
import Backdrop from "@mui/material/Backdrop";
import { NotificationManager } from "react-notifications";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { routeConstant } from "../../../../../Route/utils/routeConstant";
import { useNavigate } from "react-router";

function MapComponent(props) {
  const [polygon, setPolygon] = useState([]);
  const [center, setCenter] = useState({});
  const [bounds, setBounds] = useState();
  const [resultMessage, setResultmessage] = useState("");
  const history = useNavigate();
  const [mapData, setMapData] = useState({
    data: [],
    loading: false,
    error: false,
  });
  const context = useContext(StoreContext);
  const [showmapPointsData, setShowmapPointsData] = useState(false);
  const [locType, setLocType] = useState("");
  const [locName, setLocName] = useState("");

  useEffect(() => {
    getMapDetail();
  }, []);

  const getMapDetail = async () => {
    setMapData((prev) => ({
      ...prev,
      loading: true,
    }));
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const end_point = `${HOST_URL}api/v1/Location/ShipmentGeoCoordinates/${context.shipmentNo}`;
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };

    axios
      .get(end_point, {
        headers: header,
      })
      .then((res) => {
        setMapData({ ...mapData, loading: false });
        if (res.data.Success) {
          if (res.data?.Value?.locations) {
            setMapData({
              data: res.data?.Value.locations,
              loading: false,
              error: false,
            });

            getCoordinates(
              res.data?.Value?.route ?? [],
              res.data?.Value?.locations ?? []
            );
          }
          setResultmessage(res?.data?.ResultMessage ?? "");
          NotificationManager.success(res.data?.ResultMessage, "", 3000);
        } else {
          NotificationManager.error(res.data?.ResultMessage, "", 3000);
        }
      })
      .catch((err) => {
        setMapData({
          data: [],
          loading: false,
          error: true,
        });
      });
  };

  const getCoordinates = (data, mapObjData) => {
    let polygon = [];
    let center = {};
    let boundPoints = [];
    if (data.length) {
      console.log(data);
      let obj = {};
      data.forEach((element, index) => {
        obj = {
          lat: parseFloat(element[0]),
          lng: parseFloat(element[1]),
        };
        polygon.push(obj);
      });
      setCenter(center);
      setPolygon(polygon);
    }
    if (mapObjData.length) {
      var bound = new props.google.maps.LatLngBounds();
      mapObjData.forEach((ele) => {
        let boundObj = {
          lat: parseFloat(ele.lat),
          lng: parseFloat(ele.lng),
        };
        boundPoints.push(boundObj);
      });
      for (var i = 0; i < boundPoints.length; i++) {
        bound.extend(boundPoints[i]);
      }
      setBounds(bound);
    }
  };

  const pathOptions = {
    strokeOpacity: 1,
    strokeColor: `rgba(0, 185, 181)`,
    strokeWeight: 2,
    icons: [
      {
        icon: {
          path: props.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          strokeOpacity: 0,
          fillColor: "#0000FF",
          fillOpacity: 1.0,
          scale: 2.5,
        },
        repeat: "80px",
      },
    ],
  };

  return (
    <div className="mapComponent">
      <Map google={props.google} center={center} zoom={10} bounds={bounds}>
        {mapData.data.map((ele) => {
          return (
            <Marker
              icon={{
                url: `${HOST_URL}${ele.markerIconUrl}`,
                scaledSize: new window.google.maps.Size(25, 25),
              }}
              title={`${ele.locType}: ${ele.locName}`}
              position={{ lat: ele.lat, lng: ele.lng }}
            />
          );
        })}
        <Polyline path={polygon} options={pathOptions} />
      </Map>
      {showmapPointsData && (
        <div className="mapPointsData">{`${locType}: ${locName}`}</div>
      )}
      {mapData.loading ? (
        <div
          className="loadingContent"
          style={{
            height: "100%",
            position: "relative",
          }}
        >
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
              position: "absolute",
            }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      ) : null}
      {(context.shipmentdetails.TransportMode === "SEA" &&
        resultMessage === "Location Data Fetched Successfully") ||
      (context.shipmentdetails.TransportMode === "AIR" &&
        resultMessage === "Location Data Fetched Successfully") ? (
        <div className="mapcomponenticon">
          <OpenInNewIcon
            onClick={() => {
              if (!context.shipmentdetails.MasterBillNumber) {
                NotificationManager.error("Master BL # not found.", "", 3000);
              } else if (!context.shipmentdetails.CarrierCode) {
                NotificationManager.error("Carrier Code not found.", "", 3000);
              } else {
                history(routeConstant.Tracking, {
                  state: {
                    state: context.shipmentdetails,
                    mapData: mapData,
                    center: center,
                    polygon: polygon,
                    bounds: bounds,
                  },
                });
              }
            }}
          />
        </div>
      ) : null}
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDpfWeLTpZm0lhuv7_s-8cvKv_8sxJUHD0",
})(React.memo(MapComponent));
